/**
Project: Voice Panel (c)
Title: Device Type Actions 
Description: Number type actions for creating/modifying number type records
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import axios from "axios";
import { includes } from "lodash";
import { AppConfigProps } from "../../../../core/settings/app-config";
import {
  logMessage,
  checkIdentitySession,
  getSessionExpiredError,
} from "../../../../core/actions/common-actions";
import {
  DEVICETYPES_ALL_RECORDS,
  DEVICETYPES_PAGE_RECORDS,
  DEVICETYPES_DISPLAY_RECORDS,
} from "../../../../store/voice-admin/constants";
import { VoiceAdminConstants } from "../../common/settings/voice-admin-constants";
// import IntlUtil from "../../../../core/helpers/intl-util";

const actionFileName = "device-types-actions.js";

export function setDeviceTypesAllRecords(deviceTypesAllRecords) {
  return async function (dispatch) {
    try {
      dispatch({
        type: DEVICETYPES_ALL_RECORDS,
        payload: deviceTypesAllRecords,
      });
    } catch (err) {
      throw Error(err);
    }
  };
}

export function setDeviceTypesDisplayRecords(deviceTypesDisplayRecords) {
  return async function (dispatch) {
    try {
      dispatch({
        type: DEVICETYPES_DISPLAY_RECORDS,
        payload: deviceTypesDisplayRecords,
      });
    } catch (err) {
      throw Error(err);
    }
  };
}

export function setDeviceTypesPageRecords(deviceTypesPageRecords) {
  return async function (dispatch) {
    try {
      dispatch({
        type: DEVICETYPES_PAGE_RECORDS,
        payload: deviceTypesPageRecords,
      });
    } catch (err) {
      throw Error(err);
    }
  };
}

export function sliceDeviceTypes(list, pageOffset, pageLimit) {
  return new Promise(async function (resolve, reject) {
    if (list && list.length > 0 && pageOffset >= 0 && pageLimit > 0) {
      let start = pageOffset * pageLimit;
      let end = start + pageLimit;
      if (end > list.length) end = list.length;

      let sliceRecords = await list.slice(start, end);
      resolve(sliceRecords);
    } else {
      resolve(list);
    }
  });
}

export function searchDeviceTypes(list, searchKeyword) {
  return new Promise(async function (resolve, reject) {
    if (
      list &&
      list.length > 0 &&
      searchKeyword &&
      searchKeyword.trim().length > 0
    ) {
      let searchRecords = list.filter((type) => {
        return (
          includes(
            type?.deviceTypeName?.toLowerCase(),
            searchKeyword.trim().toLowerCase()
          ) ||
          includes(
            type?.serialNumberInclude?.toLowerCase(),
            searchKeyword.trim().toLowerCase()
          ) ||
          includes(
            type?.deviceTypeNotes?.toLowerCase(),
            searchKeyword.trim().toLowerCase()
          )
        );
      });
      resolve(searchRecords);
    } else {
      resolve(list);
    }
  });
}

export function sortDeviceTypes(list, sortColumn, sortOrder) {
  return new Promise(async function (resolve, reject) {
    if (list && list.length > 0) {
      let sortRecords = list.sort((firstItem, secondItem) => {
        switch (sortColumn) {
          // case "phoneLicenseStatus":
          //   if (
          //     sortOrder === VoiceAdminConstants.TABLE_DATA.SORT_ORDER.ASCENDING
          //   ) {
          //     return (
          //       secondItem.phoneLicenseStatus - firstItem.phoneLicenseStatus
          //     );
          //   } else {
          //     return (
          //       firstItem.phoneLicenseStatus - secondItem.phoneLicenseStatus
          //     );
          //   }
          //break;

          default:
            if (
              sortOrder === VoiceAdminConstants.TABLE_DATA.SORT_ORDER.ASCENDING
            ) {
              return firstItem[sortColumn].localeCompare(
                secondItem[sortColumn],
                "en",
                {
                  numeric: true,
                }
              );
            } else {
              return secondItem[sortColumn].localeCompare(
                firstItem[sortColumn],
                "en",
                {
                  numeric: true,
                }
              );
            }
          //break;
        }
      });
      resolve(sortRecords);
    } else {
      resolve(list);
    }
  });
}

export function getDeviceTypeList(cancelToken) {
  return new Promise(async function (resolve, reject) {
    let identitySession = checkIdentitySession();
    if (identitySession === true) {
      await axios
        .get(
          AppConfigProps.serverRoutePrefix + `/subscribers/device-types`,
          cancelToken
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          if (axios.isCancel(err)) {
            logMessage(
              AppConfigProps.log.severityLevel.warning,
              actionFileName + ">getDeviceTypeList()",
              AppConfigProps.httpStatusCode.clientClosedRequest,
              err.message
            );
          } else {
            reject(err.response);
          }
        });
    } else {
      reject(getSessionExpiredError());
    }
  });
}

export function addDeviceType(deviceTypeData, cancelToken) {
  return new Promise(async function (resolve, reject) {
    let identitySession = checkIdentitySession();
    if (identitySession === true) {
      await axios
        .post(
          AppConfigProps.serverRoutePrefix + `/subscribers/device-types`,
          deviceTypeData,
          cancelToken
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          if (axios.isCancel(err)) {
            logMessage(
              AppConfigProps.log.severityLevel.warning,
              actionFileName + ">addDeviceType()",
              AppConfigProps.httpStatusCode.clientClosedRequest,
              err.message
            );
          } else {
            reject(err.response);
          }
        });
    } else {
      reject(getSessionExpiredError());
    }
  });
}

export function updateDeviceType(deviceTypeId, deviceTypeData, cancelToken) {
  return new Promise(async function (resolve, reject) {
    let identitySession = checkIdentitySession();
    if (identitySession === true) {
      await axios
        .put(
          AppConfigProps.serverRoutePrefix + `/subscribers/device-types/${deviceTypeId}`,
          deviceTypeData,
          cancelToken
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          if (axios.isCancel(err)) {
            logMessage(
              AppConfigProps.log.severityLevel.warning,
              actionFileName + ">updateDeviceType()",
              AppConfigProps.httpStatusCode.clientClosedRequest,
              err.message
            );
          } else {
            reject(err.response);
          }
        });
    } else {
      reject(getSessionExpiredError());
    }
  });
}
